import React from "react";
import "../Styles/incubator.css";
import incubator from "../Pictures/icons8-incubator-96.png";

function Incubator() {
  return (
    <div className="incubator-container">
      <h2 className="incubator-title">Active Incubator</h2>
      <div className="no-incubator-box">
        <div className="no-incubator-box-desc">
          <img src={incubator} alt="" className="incubator-pic" />
          There is currently no active incubators
        </div>
      </div>
    </div>
  );
}

export default Incubator;
